import useFreeTrialStatus from '../../hooks/subscriptions/useFreeTrialStatus';
import ColoredAlert from '../global/ColoredAlert';
import useGetSubscriptionFromStripe from '../../hooks/subscriptions/useGetSubscriptionFromStripe';

function FreeTrialAlert() {
  const stripeQuery = useGetSubscriptionFromStripe();
  const { paymentMethod } = stripeQuery.data || {};

  const { daysRemaining, inFreeTrial } = useFreeTrialStatus();

  if (!inFreeTrial || paymentMethod) return null;

  const days = Math.max(1, daysRemaining);
  const daysString = `${days} day${days > 1 ? 's' : ''}`;

  return (
    <ColoredAlert
      animate={false}
      title="Your trial is ending soon!"
      subtitle={`Your free trial is ending in ${daysString}. To continue using Porter, you’ll need to add a payment method to your subscription. Add a payment method now to avoid your account being automatically restricted when your free trial expires.`}
      type="warning"
      dismissible
    />
  );
}

export default FreeTrialAlert;
